const PM_CHECKLIST_S3_KEY = 'pm-inspection-form.pdf';

const PM_CHECKLIST_BUCKETS: Record<string, string> = {
  staging: 'https://staging-public-images-2iyj8427.s3.us-east-2.amazonaws.com',
  production: 'https://prod-public-images-m6zzcoyk.s3.us-east-2.amazonaws.com',
};

const resolvePmChecklistUrl = (): string => {
  const env =
    process.env.REACT_APP_ENV === 'staging' ? 'staging' : 'production';
  return `${PM_CHECKLIST_BUCKETS[env]}/${PM_CHECKLIST_S3_KEY}`;
};

export const PM_CHECKLIST_PDF_URL = resolvePmChecklistUrl();
export const PM_CHECKLIST_DOWNLOAD_FILENAME = PM_CHECKLIST_S3_KEY;
export const PM_CHECKLIST_RESOURCE_ID = 'pm-checklist';
